import { topicLabels } from "./englishQuestions";
import { curated81 } from "./curated_8_1";
import { curated82 } from "./curated_8_2";
import { curated83 } from "./curated_8_3";
import { curated84Plus } from "./curated_8_4_plus";
import { curatedNumeric } from "./curated_numeric";
import { curatedNew81 } from "./curated_new_8_1";
import { curatedNew82 } from "./curated_new_8_2";
import { curatedNew83 } from "./curated_new_8_3";
import { curatedNew84 } from "./curated_new_8_4";
import { curatedNew86 } from "./curated_new_8_6";
import { curatedFactNumeric } from "./curated_fact_numeric";
import { curatedNumericComplete } from "./curated_numeric_complete";

export type { Question, Topic } from "./questionTypes";
export { topicLabels };

const completeBank = [
  ...curated81,
  ...curated82,
  ...curated83,
  ...curated84Plus,
  ...curatedNumeric,
  ...curatedNew81,
  ...curatedNew82,
  ...curatedNew83,
  ...curatedNew84,
  ...curatedNew86,
  ...curatedFactNumeric,
  ...curatedNumericComplete,
];

export const questions = completeBank.filter((question) => question.topic !== "etops");
export const ruleCount = new Set(questions.map((question) => question.familyId)).size;
